export default __webpack_public_path__ + "static/media/logo-orange.399d6812.png";